// extracted by mini-css-extract-plugin
export default {"phoneLink":"PleaseCall_phoneLink__9+Y9P"};